import ApplicationController from './application_controller'
export default class extends ApplicationController {
	static targets = ["cardContainer"];
	connect () {
		super.connect()
		console.log("connected brosef to dat fat card");


		let img = this.cardContainerTarget.querySelector(".post_card_img");

		if (img != null){
			let img_width = img.clientWidth;
			let img_height = img.clientHeight;
			console.log("img_width:", img_width);
			console.log("img_height:", img_height);

			if((img_height / img_width) < 0.75){
				img.classList.add("lookAtMe")
			}
		}

	}

}